module.exports = __webpack_public_path__ + "img/1_26@2x.d6cc903b.png";